export default "__VITE_ASSET__uKoX1JQD__"